import { Component } from '@angular/core';
import { PopulationQuery } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-badges-nav',
  templateUrl: './badges-nav.component.html',
  styleUrl: './badges-nav.component.scss'
})
export class BadgesNavComponent {
  isCorporate: boolean;
  populations = Populations;

  constructor(private populationQuery: PopulationQuery) {}

  ngOnInit(): void {
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
  }
}
